class HtmlContentError extends Error {
    /**
     * A flag to explicitly indicate that the error message is HTML.
     */
    public isHtmlContent: boolean = true;

    /**
     * Constructs a new HtmlContentError instance.
     * @param message The HTML string error message.
     */
    constructor(message: string) {
        super(message);
        this.name = 'HtmlContentError';
        Object.setPrototypeOf(this, HtmlContentError.prototype);
    }
}

class ApiHttpError extends Error {
    public readonly status: number;
    public readonly code?: string;
    public readonly responseData?: ApiErrorPayload;

    constructor(status: number, message: string, code?: string, responseData?: ApiErrorPayload) {
        super(message);
        this.name = 'ApiHttpError';
        this.status = status;
        this.code = code;
        this.responseData = responseData;
        Object.setPrototypeOf(this, ApiHttpError.prototype);
    }
}

interface ApiErrorPayload {
    error?: {
        message?: string;
    };
}

export {
    ApiHttpError,
    HtmlContentError
};
